import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {ScheduleDetails, ScheduleEvent} from 'src/app/pages/schedules/schedule';

@Component({
  selector: 'app-schedule-footer',
  templateUrl: './schedule-footer.component.html',
  styleUrls: ['./schedule-footer.component.scss'],
})
export class SchedulesFooterComponent implements OnInit {
  // Accessors
  @Input() isSchedulesLoading = false;
  @Input() selectedScheduleEvents: ScheduleEvent[] = []; // user check on check box to select schedules
  @Input() publishSchedules: Function = () => {};
  @Input() saveSchedules: Function = () => {};
  @Input() readOnlyMode = false;
  @Input() schedules: ScheduleDetails[] = [];
  @Input() isReportProblemAvailable = false;

  @Output() onManageQualifiers: EventEmitter<void> = new EventEmitter();
  @Output() onManageBlackout: EventEmitter<void> = new EventEmitter();
  @Output() onRemoveSelectedEvent: EventEmitter<void> = new EventEmitter();
  @Output() onReportProblem: EventEmitter<void> = new EventEmitter();

  // Life cycle methods
  constructor() {
  }

  ngOnInit() {
  }

  onManageQualifiersClicked() {
    this.onManageQualifiers.emit();
  }

  onRemoveSelectedEventsClicked() {
    this.onRemoveSelectedEvent.emit();
  }

  onManageBlackoutClicked() {
    this.onManageBlackout.emit();
  }

  onReportProblemClicked() {
    this.onReportProblem.emit();
  }

  displayPublishedDate(): string {
    const publishedSchedule = this.schedules?.find(schedule => !!schedule?.publishedDate);
    const publishedDate = publishedSchedule?.publishedDate;

    if (!publishedDate) {
      return 'N/A';
    }
    return publishedDate;
  }
}
